// Central configuration for the application

// Check if we're in development mode (when REACT_APP_BACKEND_URL is explicitly set)
const isDevelopment = process.env.REACT_APP_BACKEND_URL !== undefined;

export const API_CONFIG = {
  // Backend API base URL - uses environment variable if set (development), otherwise production URL
  backendUrl: process.env.REACT_APP_BACKEND_URL || 'https://mochi-vocab-linux-amd64.onrender.com',
  
  // Token storage key
  tokenKey: 'auth_token',
  
  // Environment detection
  isDevelopment,
} as const;

